import { useRef, useState } from 'react';

import { toast } from 'react-toastify';

import { KB_IN_MB, MAX_FILE_SIZE } from '@constants';
import classnames from 'classnames';

import css from './NibFileSelector.module.sass';

const NibFileSelector = ({
  children,
  accept = ['.jpg', '.png', '.jpeg'],
  maxSize = MAX_FILE_SIZE,
  onClick = () => {},
  onUpload = (file) => {},
  noStyles = false,
}) => {
  const hiddenInput = useRef(null);
  const [key, setKey] = useState(Date.now());

  const handleClick = () => {
    hiddenInput.current.click();
    onClick();
  };

  let allowedRegExp = new RegExp(`(${accept.join('|')})$`, 'i');

  const getFileWithSnakeCaseName = (file) => {
    let localFile = file;
    let fileName = localFile.name.replace(/ |-/g, '_');
    localFile = new File([localFile], fileName, { type: localFile.type });
    return localFile;
  };

  const handleUpload = (file) => {
    if (!file) return;
    if (file.size / KB_IN_MB > maxSize) {
      return toast.error(`File cannot be larger than ${maxSize / KB_IN_MB}MB`);
    } else if (!allowedRegExp.exec(file.name)) {
      return toast.error('This extension is not supported');
    }
    onUpload(getFileWithSnakeCaseName(file));
    setKey(Date.now());
  };

  return (
    <div className={noStyles ? '' : classnames(css.uploadWrap, 'ui-file-selector-wrapper')}>
      <input
        ref={(el) => (hiddenInput.current = el)}
        key={key}
        type="file"
        style={{ display: 'none' }}
        accept={accept.join(', ')}
        onChange={(e) => handleUpload(e.target.files[0])}
        onBlur={(e) => handleUpload(e.target.files[0])}
      />
      {children(handleClick)}
    </div>
  );
};

export default NibFileSelector;
